module.exports = __webpack_public_path__ + "static/media/kazehaya_shof301ccb5c2ac4850deda2be732860535.webp";